import { generalCountriesData } from '../country/constants';

export function getDefaultCurrencyCodeByCountry(country: string) {
  switch (country.toLowerCase()) {
    case 'id':
      return 'IDR';
    case 'kr':
      return 'KRW';
    case 'jp':
      return 'JPY';
    default: {
      const found = generalCountriesData.find((c) => c.alpha2.toLocaleLowerCase() === country.toLowerCase());
      return (found && found.currencies[0]) || 'USD';
    }
  }
}
